<script lang="ts" setup>
import { onMounted } from '#imports';
import { useService } from '@kaokei/use-vue-service';
import HTInputPhone from '@core/components/HTInputPhone.vue';
import HTInputVerifyCode from '@core/components/HTInputVerifyCode.vue';
import HTLinkButton from '@core/components/HTLinkButton.vue';
import { BindphoneService } from '@core/services/bindphone.service';

const service = useService(BindphoneService);

onMounted(() => {
  service.init();
});
</script>

<template>
  <a-modal
    v-model:open="service.visible"
    width="420px"
    :footer="null"
    :closable="false"
    :mask-closable="false"
    :destroy-on-close="true"
  >
    <HTLinkButton
      class="hover:!text-info absolute right-[22px] top-[29px] text-base !text-[#00000066]"
      @click="service.handleLogout"
      >退出登录</HTLinkButton
    >
    <div class="title">绑定手机号</div>
    <div class="form-wrapper">
      <a-form
        class="hetao-form"
        layout="vertical"
        :model="service.model"
        :rules="service.rules"
        @finish="service.handleOnFinish"
        @validate="service.handleOnValidate"
      >
        <a-form-item name="phoneNumber">
          <HTInputPhone
            v-model:short="service.model.short"
            v-model:code="service.model.countryCode"
            v-model:value="service.model.phoneNumber"
            v-model:pattern="service.phoneNumberPattern"
            :maxlength="11"
            placeholder="输入手机号"
            autocomplete="tel"
            :allow-clear="true"
            size="large"
          />
        </a-form-item>

        <a-form-item name="verifyCode">
          <HTInputVerifyCode
            v-model:value="service.model.verifyCode"
            autocomplete="one-time-code"
            placeholder="输入验证码"
            :maxlength="6"
            :countdown="service.countdownSecond"
            :verify-code-disabled="!service.validModel.phoneNumber"
            size="large"
            @send-verify-code="service.handleSendVerifyCode"
          />
        </a-form-item>

        <a-form-item>
          <a-button
            type="primary"
            class="disabled-opacity !text-base !font-bold"
            block
            html-type="submit"
            size="large"
            :loading="service.loading"
            :disabled="service.formDisabled"
          >
            提交
          </a-button>
        </a-form-item>
      </a-form>
    </div>
  </a-modal>
</template>

<style scoped>
.title {
  position: absolute;
  left: 0;
  top: 30px;
  height: 30px;
  line-height: 30px;
  padding-left: 26px;
  color: theme('colors.font1');
  font-size: 18px;
  font-weight: bold;
}

.title::after {
  position: absolute;
  height: 30px;
  left: 0;
  top: 0;
  content: ' ';
  width: 8px;
  background: theme('colors.primary');
}

.form-wrapper {
  padding: 90px 28px 36px;
}
</style>
